import registerWebloyality from '@white-label-plugin/register-webloyalty';

registerWebloyality();
